// extracted by mini-css-extract-plugin
export default {"container":"styles,_container__gNHJs","divider":"styles,_divider__R0ah4","lang_select":"styles,_lang_select__ZBtq8","lang_select_active":"styles,_lang_select_active__5hjSz"};